import { Component, input } from "@angular/core";
import { MaterialModule } from "src/app/core/material/material.module";

@Component({
  selector: "app-label-input",
  imports: [MaterialModule],
  templateUrl: "./label-input.component.html",
})
export class LabelInputComponent {
  readonly textLabel = input<string>();
  readonly required = input<boolean>();
  readonly hasTooltip = input<boolean>();
  readonly textTooltip = input<string>();
}
